export const ENABLE_AUTO_SCROLL_ON_CONSEQUENT_STEPS = false;
export const WIZARD_DESCRIPTION_COLOR = Styles.color.secondary;
export const MIN_PICKER_ASPECT_OPTIONS = 6;
